export default __webpack_public_path__ + "static/parseur-b4fdcc1d51e0ef1cc9053219eb87c3a2.png";